module.exports = __webpack_public_path__ + "static/media/arrow-right-round.f3b3948d.png";